import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import DatePicker from "@components/rangeDatePicker";
import {X} from "react-feather";
import "./style.scss";

const RangeDateFilter = ({data}) => {
    const {key, label, unit, options} = data;

    const minKeyYear = `${key}[min][year]`;
    const minKeyMonth = `${key}[min][month]`;
    const minKeyDay = `${key}[min][day]`;

    const maxKeyYear = `${key}[max][year]`;
    const maxKeyMonth = `${key}[max][month]`;
    const maxKeyDay = `${key}[max][day]`;

    const [searchParams, setSearchParams] = useSearchParams();
    const defaultMinYear = searchParams.get(minKeyYear);
    const defaultMinMonth = searchParams.get(minKeyMonth);
    const defaultMinDay = searchParams.get(minKeyDay);

    const defaultMaxYear = searchParams.get(maxKeyYear);
    const defaultMaxMonth = searchParams.get(maxKeyMonth);
    const defaultMaxDay = searchParams.get(maxKeyDay);

    const initDateRange = {
        from: defaultMinYear &&
            defaultMinMonth &&
            defaultMinDay && {
                year: parseInt(defaultMinYear),
                month: parseInt(defaultMinMonth),
                day: parseInt(defaultMinDay)
            },
        to: defaultMaxYear &&
            defaultMaxMonth &&
            defaultMaxDay && {
                year: parseInt(defaultMaxYear),
                month: parseInt(defaultMaxMonth),
                day: parseInt(defaultMaxDay)
            }
    };
    const [rangeValues, setRangeValues] = useState(initDateRange);

    const handleChangeRange = (value) => {
        setRangeValues(value);

        let newParamsQuery = new URLSearchParams(searchParams);
        if (newParamsQuery.get("page")) {
            newParamsQuery.delete("page");
            setSearchParams(newParamsQuery);
        }
    };

    const clearFilter = () => {
        setRangeValues({from: "", to: ""});
        const newParamsQuery = new URLSearchParams(searchParams);
        [
            minKeyYear,
            minKeyMonth,
            minKeyDay,
            maxKeyYear,
            maxKeyMonth,
            maxKeyDay
        ].forEach((key) => newParamsQuery.delete(key));
        setSearchParams(newParamsQuery);
    };

    const setValueToUrl = () => {
        const newParamsQuery = new URLSearchParams(searchParams);
        if (rangeValues?.from && rangeValues?.to) {
            const {from, to} = rangeValues;
            newParamsQuery.set(minKeyYear, from.year);
            newParamsQuery.set(minKeyMonth, from.month);
            newParamsQuery.set(minKeyDay, from.day);
            newParamsQuery.set(maxKeyYear, to.year);
            newParamsQuery.set(maxKeyMonth, to.month);
            newParamsQuery.set(maxKeyDay, to.day);
        } else {
            [
                minKeyYear,
                minKeyMonth,
                minKeyDay,
                maxKeyYear,
                maxKeyMonth,
                maxKeyDay
            ].forEach((key) => newParamsQuery.delete(key));
        }
        setSearchParams(newParamsQuery);
    };

    useEffect(() => {
        if (rangeValues?.from && rangeValues?.to) {
            setValueToUrl();
        }
    }, [rangeValues]);

    return (
        <section className="range-date-filter">
            <h6>{label}</h6>
            <div className="d-flex justify-content-between">
                <DatePicker
                    handleDateRangeChange={handleChangeRange}
                    dateRange={rangeValues}
                    minimumDate={options.min}
                    maximumDate={options.max}
                />
                {rangeValues?.from && rangeValues?.to && (
                    <X size={18} className="my-auto" onClick={clearFilter}/>
                )}
            </div>
        </section>
    );
};

export default RangeDateFilter;
